import { useState } from 'react'
import {
  Card,
  Collapse,
} from 'reactstrap';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';


const OverUnder = ({ data }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isOpen2, setIsOpen2] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const toggle2 = () => setIsOpen2(!isOpen2);

  return (
    <Card className="general">
      {isOpen ?
        <button onClick={toggle} className="visibility_headtohead ">
          <VisibilityIcon style={{ width: "15px", height: "15px" }} />
        </button> :
        <button onClick={toggle} className="visibility_headtohead_closed ">
          <VisibilityOffIcon style={{ width: "15px", height: "15px" }} />
        </button>
      }
      {!isOpen &&
        <div>
          <h4 className="headtohead_title">Over / Under (FT)</h4>
        </div>
      }
      <Collapse isOpen={isOpen} className="over-content">
        <div className="bars_div_over">
          <h2>Over / Under (FT)</h2>
          {data.overs &&
            <div className="general-progress">
              <div>
                <div className="progress-titles">
                  <h3>Over</h3>
                  <h3>0,5</h3>
                  <h3>Under</h3>
                </div>
                <div className="progress-over">
                  {data['overs']['0.5'] &&
                    <>
                      <p>{`${(100 - data['overs']['0.5']).toFixed(2)}%`} </p>
                      <div className="progress-done-over" style={{ width: `${data['overs']['0.5']}%` }}>
                        <span>{data['overs']['0.5']}%</span>
                      </div>
                    </>}
                </div>
              </div>
              <div>
                <div className="progress-titles">
                  <h3>Over</h3>
                  <h3>1,5</h3>
                  <h3>Under</h3>
                </div>
                <div className="progress-over">
                  {data['overs']['1.5'] &&
                    <>
                      <p>{`${(100 - data['overs']['1.5']).toFixed(2)}%`} </p>
                      <div className="progress-done-over" style={{ width: `${data['overs']['1.5']}%` }}>
                        <span>{data['overs']['1.5']}%</span>
                      </div>
                    </>}
                </div>
              </div>
              <div>
                <div className="progress-titles">
                  <h3>Over</h3>
                  <h3>2,5</h3>
                  <h3>Under</h3>
                </div>
                <div class="progress-over">
                  {data['overs']['2.5'] &&
                    <>
                      <p>{`${(100 - data['overs']['2.5']).toFixed(2)}%`} </p>
                      <div className="progress-done-over" style={{ width: `${data['overs']['2.5']}%` }}>
                        <span>{data['overs']['2.5']}%</span>
                      </div>
                    </>}
                </div>
              </div>
              <div>
                <div className="progress-titles">
                  <h3>Over</h3>
                  <h3>3,5</h3>
                  <h3>Under</h3>
                </div>
                <div class="progress-over">
                  {data['overs']['3.5'] &&
                    <>
                      <p>{`${(100 - data['overs']['3.5']).toFixed(2)}%`} </p>
                      <div className="progress-done-over" style={{ width: `${data['overs']['3.5']}%` }}>
                        <span>{data['overs']['3.5']}%</span>
                      </div>
                    </>}
                </div>
              </div>
              <div>
                <div className="progress-titles">
                  <h3>Over</h3>
                  <h3>4,5</h3>
                  <h3>Under</h3>
                </div>
                <div class="progress-over">
                  {data['overs']['4.5'] &&
                    <>
                      <p>{`${(100 - data['overs']['4.5']).toFixed(2)}%`} </p>
                      <div className="progress-done-over" style={{ width: `${data['overs']['4.5']}%` }}>
                        <span>{data['overs']['4.5']}%</span>
                      </div>
                    </>}
                </div>
              </div>
              <div>
                <div className="progress-titles">
                  <h3>Over</h3>
                  <h3>5,5</h3>
                  <h3>Under</h3>
                </div>
                <div class="progress-over">
                  {data['overs']['5.5'] &&
                    <>
                      <p>{`${(100 - data['overs']['5.5']).toFixed(2)}%`} </p>
                      <div className="progress-done-over" style={{ width: `${data['overs']['5.5']}%` }}>
                        <span>{data['overs']['5.5']}%</span>
                      </div>
                    </>}
                </div>
              </div>
            </div>}
          {isOpen2 ?
            <button onClick={toggle2} className="sub-toggle-close">
              <ExpandLessRoundedIcon style={{ width: "15px", height: "15px" }} />
            </button> :
            <button onClick={toggle2} className="sub-toggle-open">
              <ExpandMoreRoundedIcon style={{ width: "15px", height: "15px" }} />
            </button>}
          <Collapse isOpen={isOpen2}>
            {data.overs &&
              <div className="subbars_div">
                <div className="general-progress">
                  <div>
                    <div className="progress-titles">
                      <h3>Over</h3>
                      <h3>6,5</h3>
                      <h3>Under</h3>
                    </div>
                    <div className="progress-over">
                      {data['overs']['6.5'] &&
                        <>
                          <p>{`${(100 - data['overs']['6.5']).toFixed(2)}%`} </p>
                          <div className="progress-done-over" style={{ width: `${data['overs']['6.5']}%` }}>
                            <span>{data['overs']['6.5']}%</span>
                          </div>
                        </>}
                    </div>
                  </div>
                  <div>
                    <div className="progress-titles">
                      <h3>Over</h3>
                      <h3>7,5</h3>
                      <h3>Under</h3>
                    </div>
                    <div class="progress-over">
                      {data['overs']['7.5'] &&
                        <>
                          <p>{`${(100 - data['overs']['7.5']).toFixed(2)}%`} </p>
                          <div className="progress-done-over" style={{ width: `${data['overs']['7.5']}%` }}>
                            <span>{data['overs']['7.5']}%</span>
                          </div>
                        </>}
                    </div>
                  </div>
                  <div>
                    <div className="progress-titles">
                      <h3>Over</h3>
                      <h3>8,5</h3>
                      <h3>Under</h3>
                    </div>
                    <div class="progress-over">
                      {data['overs']['8.5'] &&
                        <>
                          <p>{`${(100 - data['overs']['8.5']).toFixed(2)}%`} </p>
                          <div className="progress-done-over" style={{ width: `${data['overs']['8.5']}%` }}>
                            <span>{data['overs']['8.5']}%</span>
                          </div>
                        </>}
                    </div>
                  </div>
                  <div>
                    <div className="progress-titles">
                      <h3>Over</h3>
                      <h3>9,5</h3>
                      <h3>Under</h3>
                    </div>
                    <div class="progress-over">
                      {data['overs']['9.5'] &&
                        <>
                          <p>{`${(100 - data['overs']['9.5']).toFixed(2)}%`} </p>
                          <div className="progress-done-over" style={{ width: `${data['overs']['9.5']}%` }}>
                            <span>{data['overs']['9.5']}%</span>
                          </div>
                        </>}
                    </div>
                  </div>
                  <div>
                    <div className="progress-titles">
                      <h3>Over</h3>
                      <h3>10,5</h3>
                      <h3>Under</h3>
                    </div>
                    <div class="progress-over">
                      {data['overs']['10.5'] &&
                        <>
                          <p>{`${(100 - data['overs']['10.5']).toFixed(2)}%`} </p>
                          <div className="progress-done-over" style={{ width: `${data['overs']['10.5']}%` }}>
                            <span>{data['overs']['10.5']}%</span>
                          </div>
                        </>}
                    </div>
                  </div>
                </div>
              </div>}
          </Collapse>
        </div>
      </Collapse>
    </Card>
  )
}

export default OverUnder
